import {
  type Form,
  type NestedForm,
} from '@wix/ambassador-forms-v4-form/types';

import { type FormsById } from '../types';

export type FormsByTarget = { [target: string]: Form };

export function applyNestedForms(
  form: Form,
  nestedFormsById?: FormsById,
): Form {
  if (!form.nestedForms && !nestedFormsById) {
    return form;
  }

  const nestedFormsByTarget = getNestedFormsByTarget(form);

  return {
    ...form,
    fields: form.fields?.map((field) => {
      const fieldTarget = field.target;
      if (!fieldTarget) {
        return field;
      }

      const nestedFormId = field.nestedFormId;
      if (!nestedFormId) {
        return field;
      }

      const nestedForm: Form | undefined =
        nestedFormsByTarget?.[fieldTarget] ?? nestedFormsById?.[nestedFormId];

      if (nestedForm) {
        return { ...field, view: { ...field.view, form: nestedForm } };
      }

      return field;
    }),
  };
}

export function getNestedFormsByTarget(form: Form) {
  return form.nestedForms?.reduce<FormsByTarget>(
    (byTarget, { targets, form: nestedForm }) => {
      if (!nestedForm || !targets) {
        return byTarget;
      }
      for (const target of targets) {
        byTarget[target] = nestedForm;
      }
      return byTarget;
    },
    {},
  );
}

export function getNestedFormArray(formsByTarget: FormsByTarget): NestedForm[] {
  return Object.keys(formsByTarget).map((target) => {
    return { targets: [target], form: formsByTarget[target] };
  });
}
